module.exports = __webpack_public_path__ + "static/media/codaisseur-project-cowbell.0ffb5d6b.md";